import { Icon, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { ReactNode } from "react";

import { cn } from "@/utils";

interface SelectionCardProps {
  label: string;
  subLabel: string | ReactNode;
  icon: IconVariants;
  onClick: () => void;
  borderStyle?: "solid" | "dotted";
  disabled?: boolean;
}

export default function SelectionCard({ label, subLabel, icon, onClick, borderStyle = "solid", disabled = false }: SelectionCardProps) {
  const borderWidthClass = borderStyle === "dotted" ? "border-2" : "border-1";
  const borderStyleClass = borderStyle === "dotted" ? "border-dashed" : "border-solid";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "flex flex-col gap-lg items-center cursor-pointer p-lg rounded-lg",
        "bg-gray-3 hover:bg-gray-4 border-gray-6 hover:border-gray-9/50 dark:hover:border-gray-8",
        borderWidthClass,
        borderStyleClass,
        disabled && "opacity-50 cursor-not-allowed pointer-events-none",
      )}
    >
      <Icon icon={icon} size={IconSize.XLARGE} />
      {label.length > 0 && <Text variant={TextVariants.HEADING_5_BOLD}>{label}</Text>}
      <Text variant={TextVariants.LABEL_LARGE_REGULAR} className="text-gray-12">
        {subLabel}
      </Text>
    </button>
  );
}
